module.exports = __webpack_public_path__ + "img/9280cb3e013e7bec2185f125ac79c36a.svg";